import { Link } from "react-router-dom"
import { cn } from "../../../../lib/utils.js"
import {
  SidebarMenuButton,
  SidebarMenuItem as SidebarMenuItemPrimitive,
} from "../../../ui/sidebar.js"

/**
 * Item de menu simples (link).
 */
export function SidebarMenuItem({
  item,
  collapsed,
  isMobile,
  isActive,
  onNavigate,
  onActiveMenuChange,
}) {
  const Icon = item.icon

  return (
    <SidebarMenuItemPrimitive>
      <SidebarMenuButton
        asChild
        isActive={isActive}
        tooltip={collapsed && !isMobile ? item.label : undefined}
        className={cn(
          "relative flex h-10 w-full items-center rounded-lg p-0 text-[13px] font-medium text-gray-400 transition-colors hover:!bg-gray-900 hover:!text-white active:!bg-gray-900 active:!text-white data-[active=true]:!bg-gray-800 data-[active=true]:!text-white",
          collapsed && !isMobile
            ? "justify-center px-0"
            : "justify-start gap-2.5 px-3",
          isActive && "border-l-2 border-white bg-gray-800 text-white",
        )}
      >
        <Link
          to={item.href}
          onClick={() => {
            onActiveMenuChange(item.id)
            onNavigate(item.href, item.label)
          }}
        >
          <Icon size={20} className="flex-shrink-0" />
          {/* TODO - Implementar modulo de notificações */}
          {(!collapsed || isMobile) && (
            <>
              <span className="truncate leading-tight">{item.label}</span>
              {/* {item.hasIndicator && (
                <span className="ml-auto h-1.5 w-1.5 rounded-full bg-red-500" />
              )} */}
            </>
          )}
          {/* {item.hasIndicator && collapsed && !isMobile && (
            <span className="hidden h-1.5 w-1.5 rounded-full bg-red-500 lg:block absolute top-2 right-2" />
          )} */}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItemPrimitive>
  )
}
